import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class clearQueryParamsService {
    constructor(
      private readonly _router: Router,
      private readonly _activatedRoute: ActivatedRoute,
    ) {}

    checkIfQueryParamsExists(): void {
      let params = [];
      this._activatedRoute.queryParams.subscribe(x => {
        if (Object.keys(x).length > 0) params.push(x);
      })
      
      if (params.length > 0) this.clearQueryParams();
    }

    clearQueryParams(): void {
      this._router.navigate([], {
        relativeTo: this._activatedRoute,
        queryParams: {},
        replaceUrl: true,
      });
    }
}